<script setup lang="ts">
    import { InputRow, MultiCombobox } from '@/components/ui/form';
    import { Textarea } from '@/components/ui/textarea';
    import { Input } from '@/components/ui/input';
    import { useI18n } from 'vue-i18n';
    import Permission from '@/enums/Permission';
    import { usePermissions } from '@/composables/usePermissions';
    import { useProcedureResponsiblesData } from '@/composables/useProcedureResponsiblesData';

    const props = defineProps<{
        form: any;
    }>();

    const { hasPermission } = usePermissions();

    const { procedureResponsibles, isProcedureResponsiblesPending } =
        useProcedureResponsiblesData();

    const { t } = useI18n();
</script>

<template>
    <div class="flex flex-col gap-3">
        <InputRow
            :form="form"
            name="procedure_task"
            label="dashboards.procedures"
        >
            <Textarea
                id="procedure_task"
                v-model="form.procedure_task"
                :placeholder="t('dashboards.procedures')"
                :disabled="!hasPermission(Permission.DASHBOARD_ADMIN_UPDATE)"
            />
        </InputRow>

        <InputRow
            :form="form"
            name="procedure_responsible"
            label="dashboards.procedures_choose_responsible"
        >
            <MultiCombobox
                v-model="form.procedure_responsible"
                :options="procedureResponsibles"
                :show-remove-button="false"
                :loading="isProcedureResponsiblesPending"
                :disabled="!hasPermission(Permission.DASHBOARD_ADMIN_UPDATE)"
                label-by="name"
                value-by="id"
            />
        </InputRow>

        <InputRow
            :form="form"
            name="procedure_deadline"
            label="dashboards.tasks_deadline"
        >
            <Input
                v-model="form.procedure_deadline"
                :disabled="!hasPermission(Permission.DASHBOARD_ADMIN_UPDATE)"
                type="number"
                :placeholder="t('dashboards.tasks_deadline')"
            />
        </InputRow>
    </div>
</template>
